import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 5rem;

  h1 {
    ${(props) => `
      color: ${props.theme.colors.blackTextBody};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 0;
  }

  h2 {
    ${(props) => `
      color: ${props.theme.colors.gray};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 1.6rem;
  }
`;

export const RowContainer = styled.div`
  margin: 2.5rem 0;
  width: 100%;

  .warning-message {
    background-color: ${(props) =>
      props.theme.colors.supportYellow + props.theme.transparencies.p20};
    color: ${(props) => props.theme.colors.blackTextBody};

    border-radius: 10px;
    display: flex;
    margin-top: 1.5rem;
    width: 51rem;
  }

  p {
    font-family: ${(props) => props.theme.fontFamilies.primaryFont};
    font-size: 1.4rem;
    font-weight: 500;
  }

  img {
    filter: invert(0%) sepia(0%) saturate(0%) hue-rotate(106deg) brightness(30%)
      contrast(105%);
    padding-left: 1.5rem;
    padding-right: 1rem;
  }
`;

export const Row = styled.div`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;

  h2 {
    ${(props) => `
      color: ${
        props.theme.colors.blackTextBody + props.theme.transparencies.p30
      };
    `}
    font-size: 1.2rem;
    font-weight: 700;
    margin-bottom: 1rem;
  }

  select {
    height: 5rem;
    padding: 1.3rem 0.5rem 1.3rem 1.3rem;
  }

  .clickable-element {
    cursor: pointer;
  }
`;

export const MainButton = styled.button`
  ${(props) => `
    background-color: ${
      props.disabled ? "#002e6c63" : props.theme.colors.primaryFont
    };
    color: ${props.theme.colors.white};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  justify-content: center;
  margin-top: 1rem;
  min-height: 5.5rem;
  width: 29rem;
`;
export const DivDate = styled.div`
  .clickable-element .react-date-picker__wrapper {
    border: 0px solid white;
  }
`;

export const DivFlex = styled.div`
  align-items: flex-end;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

export const DivMessage = styled.div`
  align-items: center;
  display: flex;
  height: 26rem;
  justify-content: center;
`;
